import { clothing, clothingById } from '../../../data/config';
import type { ClothingSlot } from '../../../core/domain/types';
import { useGameStore } from '../../../store/gameStore';
import { useUiStore } from '../../../store/uiStore';

const slotNames: Record<ClothingSlot, string> = {
  hat: '帽子',
  top: '上衣',
  bottom: '下装',
  shoes: '鞋子',
  dress: '连衣裙',
};

export function WardrobePanel() {
  const wardrobe = useGameStore((state) => state.game.wardrobe);
  const actions = useGameStore((state) => state.actions);
  const showNotice = useUiStore((state) => state.showNotice);
  const equipped = wardrobe.preview ?? wardrobe.equipped;

  return (
    <section className="control-panel" data-tutorial-target="wardrobe-outfit">
      <div className="panel-heading">
        <h2>我的服装（{wardrobe.ownedClothingIds.length}/50）</h2>
        <span>{wardrobe.preview ? '正在试穿' : '当前搭配'}</span>
      </div>
      <div className="wardrobe-list">
        {wardrobe.ownedClothingIds.map((id) => {
          const item = clothingById.get(id);
          if (!item) return null;
          return (
            <button
              key={id}
              className={equipped[item.slot] === id ? 'clothing-card selected' : 'clothing-card'}
              onClick={() => actions.previewClothing(id)}
              style={{ '--item-color': item.color } as React.CSSProperties}
            >
              <span className="swatch" />
              <span>{item.name}</span>
              <small>{slotNames[item.slot]}</small>
            </button>
          );
        })}
      </div>
      <div className="action-row">
        <button onClick={() => actions.randomizeOutfit()}>随机搭配</button>
        <button className="primary-button" onClick={() => actions.confirmOutfit()}>
          确认穿搭
        </button>
        <button onClick={() => actions.cancelOutfit()}>取消试穿</button>
        <button
          onClick={() => {
            const result = actions.saveOutfit();
            showNotice(result.ok ? '搭配已保存。' : result.message);
          }}
        >
          保存搭配（{wardrobe.savedOutfits.length}/5）
        </button>
      </div>
      <p className="hint">商店中共有 {clothing.length} 件占位服装，随着等级逐步解锁。</p>
    </section>
  );
}
